import { connect } from 'react-redux';
import { showRememberMeSelector } from '../../../config/ab/selector';
import { INITIAL_BOOKING_ROOT_KEY } from '../../constants';
import LazyLoginModalView from './LazyLoginModalView';

const mapStateToProps = (state, ownProps) => {
    const bookingPage = state[INITIAL_BOOKING_ROOT_KEY];

    return {
        appleLoginUrl:
            bookingPage.showAppleLoginButton === 'True'
                ? bookingPage.appleLoginUrl
                : '',
        facebookLoginUrl: bookingPage.facebookLoginUrl,
        googleLoginUrl: bookingPage.googleLoginUrl,
        showRememberMe: showRememberMeSelector(state),
    };
};

export default connect(mapStateToProps)(LazyLoginModalView);
